export default __webpack_public_path__ + "static/media/excel-blue.49ec61b7.svg";